import React, { useRef } from "react";
import "../ArticleSection/articleSection.css";
import ArticleCard from "../ArticleCard/ArticleCard";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CarouselCard from "../CarouselCard/CarouselCard";
import hub1 from "../../../assets/articles/hub-1.webp";
import hub2 from "../../../assets/articles/hub-2.webp";
import hub3 from "../../../assets/articles/hub-3.webp";
import hub4 from "../../../assets/articles/hub-4.webp";
import hub5 from "../../../assets/articles/hub-5.webp";
import hub6 from "../../../assets/articles/hub-6 (1).webp";

export default function ArticleSection(props) {
  const isMobile = window.innerWidth < 980;
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    arrows: false,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="article-section">
      <h2 className="article-header">Artiklar om oss</h2>
      {isMobile === true ? (
        <div className="article-mobile-slider">
          <Slider ref={sliderRef} {...settings}>
            <CarouselCard
              link={
                "https://www.svt.se/nyheter/lokalt/stockholm/jobbhubb-ska-underlatta-vardagspusslet-for-tullingebor"
              }
              img={hub1}
              imgAlt={"Kontorsmiljö med flera skrivbord i rad, utrustade med datorskärmar, tangentbord och skrivbordslampor i ett öppet kontorslandskap"}
              title={"SVT Nyheter"}
              quote={"Jobb ska göra Tullingebors livspussel lättare"}
            />
            <CarouselCard
              link={
                "https://www.dn.se/sthlm/flexibelt-kvarterskontor-ska-ta-vara-pa-positiva-pandemieffekter/"
              }
              img={hub2}
              imgAlt={"Ljust kontor med höj- och sänkbara skrivbord, datorskärmar och stolar placerade längs en korridor med trägolv"}
              title={"Dagens Nyheter"}
              quote={
                "Flexibel kvarterskontor ska ta vara på positiva pandemieffekter"
              }
            />
            <CarouselCard
              link={
                "https://fastighetstidningen.se/nyhet/kliver-drakarna-in-i-vakansas-kontorslosning/#:~:text=Snart%20vet%20vi%20om%20Robin%20Rushdi%20Al-s%C3%A1lehi%20lyckas,i%20den%20fj%C3%A4rde%20s%C3%A4songen%20av%20Svt%3As%20entrepren%C3%B6rsprogram%20Drakn%C3%A4stet"
              }
              img={hub3}
              imgAlt={"Modernt kontorsrum med flera arbetsstationer, kontorsstolar och stora fönster som släpper in dagsljus"}
              title={"Fastighetstidningen"}
              quote={"Kliver drakarna in i Vakansas delningslösning?"}
            />
            <CarouselCard
              link={
                "https://www.ri.se/sv/vad-vi-gor/cirkular-omstallning/cirkulara-kartan/vakansa"
              }
              img={hub4}
              imgAlt={"Färgglatt kontor med pingisbord, arbetsplatser och dekorativa väggar i blått och gult"}
              title={"RISE"}
              quote={
                "Vakansa förvaltar tiden i byggnader och lokaler så att de används resurseffektivt"
              }
            />
            <CarouselCard
              link={
                "https://www.aktuellhallbarhet.se/alla-nyheter/karriar/fran-hallbarhetschef-till-start-up-entreprenor/"
              }
              img={hub5}
              imgAlt={"Mötesrum med stort bord, flera stolar och stora fönster som ger utsikt och naturligt ljus"}
              title={"Aktuell Hållbarhet"}
              quote={
                "Från hållbarhetschef till start up-entreprenör"
              }
            />
            <CarouselCard
              link={
                "https://unt.se/bli-prenumerant/artikel/kr2zonvr/unt-1m1kr_s_23"
              }
              img={hub6}
              imgAlt={"Stort öppet kontorsutrymme med konferensbord, kontorsstolar och takbelysning i en modern miljö"}
              title={"UNT"}
              quote={"Uppsalabo utmanar fastighetsbranschen med ny plattform"}
            />
          </Slider>
          <div className="article-arrows">
            <svg
              fill="currentColor"
              viewBox="0 0 16 16"
              height="1em"
              width="1em"
              className="article-arrow article-arrow-prev"
              onClick={() => sliderRef.current?.slickPrev()}
            >
              <path
                fillRule="evenodd"
                d="M11.354 1.646a.5.5 0 010 .708L5.707 8l5.647 5.646a.5.5 0 01-.708.708l-6-6a.5.5 0 010-.708l6-6a.5.5 0 01.708 0z"
              />
            </svg>
            <svg
              fill="currentColor"
              viewBox="0 0 16 16"
              height="1em"
              width="1em"
              className="article-arrow article-arrow-next"
              onClick={() => sliderRef.current?.slickNext()}
            >
              <path
                fillRule="evenodd"
                d="M4.646 1.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 01-.708-.708L10.293 8 4.646 2.354a.5.5 0 010-.708z"
              />
            </svg>
          </div>
        </div>
      ) : (
        <>
          {isMobile === false ? (
            <div className="articles">
              <ArticleCard
                link={
                  "https://www.svt.se/nyheter/lokalt/stockholm/jobbhubb-ska-underlatta-vardagspusslet-for-tullingebor"
                }
                img={hub1}
                imgAlt={"Kontorsmiljö med flera skrivbord i rad, utrustade med datorskärmar, tangentbord och skrivbordslampor i ett öppet kontorslandskap"}
                title={"SVT Nyheter"}
                quote={"Jobb ska göra Tullingebors livspussel lättare"}
              />
              <ArticleCard
                link={
                  "https://www.dn.se/sthlm/flexibelt-kvarterskontor-ska-ta-vara-pa-positiva-pandemieffekter/"
                }
                img={hub2}
                imgAlt={"Ljust kontor med höj- och sänkbara skrivbord, datorskärmar och stolar placerade längs en korridor med trägolv"}
                title={"Dagens Nyheter"}
                quote={
                  "Flexibel kvarterskontor ska ta vara på positiva pandemieffekter"
                }
              />
              <ArticleCard
                link={"https://fastighetstidningen.se/nyhet/kliver-drakarna-in-i-vakansas-kontorslosning/#:~:text=Snart%20vet%20vi%20om%20Robin%20Rushdi%20Al-s%C3%A1lehi%20lyckas,i%20den%20fj%C3%A4rde%20s%C3%A4songen%20av%20Svt%3As%20entrepren%C3%B6rsprogram%20Drakn%C3%A4stet"}
                img={hub3}
                imgAlt={"Modernt kontorsrum med flera arbetsstationer, kontorsstolar och stora fönster som släpper in dagsljus"}
                title={"Fastighetstidningen"}
                quote={"Kliver drakarna in i Vakansas delningslösning?"}
              />
              <ArticleCard
                link={
                  "https://www.ri.se/sv/vad-vi-gor/cirkular-omstallning/cirkulara-kartan/vakansa"
                }
                img={hub4}
                imgAlt={"Färgglatt kontor med pingisbord, arbetsplatser och dekorativa väggar i blått och gult"}
                title={"RISE"}
                quote={
                  "Vakansa förvaltar tiden i byggnader och lokaler så att de används resurseffektivt"
                }
              />
              <ArticleCard
                link={
                  "https://www.aktuellhallbarhet.se/alla-nyheter/karriar/fran-hallbarhetschef-till-start-up-entreprenor/"
                }
                img={hub5}
                imgAlt={"Mötesrum med stort bord, flera stolar och stora fönster som ger utsikt och naturligt ljus"}
                title={"Aktuell Hållbarhet"}
                quote={"Från hållbarhetschef till start up-entreprenör"}
              />
              <ArticleCard
                link={
                  "https://unt.se/bli-prenumerant/artikel/kr2zonvr/unt-1m1kr_s_23"
                }
                img={hub6}
                imgAlt={"Stort öppet kontorsutrymme med konferensbord, kontorsstolar och takbelysning i en modern miljö"}
                title={"UNT"}
                quote={"Uppsalabo utmanar fastighetsbranschen med ny plattform"}
              />
            </div>
          ) : null}
        </>
      )}
    </div>
  );
}